import React, { useEffect } from "react";

export function BankReaderCallbackTinkView() {
  useEffect(() => {
    const url = new URL(window.location.href);
    const search = url.searchParams;
    const error = search.get("error");
    const event = generateEvent(search, !!error);
    console.log(event.data);
    window.parent.dispatchEvent(event);
  }, []);

  const generateEvent = (search, hasError) => {
    if (hasError) {
      return new MessageEvent("message", {
        data: {
          msg: "bankReaderTinkWidget:ko",
          createdAt: new Date(),
          error: search.get("error"),
          errorReason: search.get("error_reason"),
          message: search.get("message"),
        },
      });
    }
    return new MessageEvent("message", {
      data: {
        msg: "bankReaderTinkWidget:ok",
        createdAt: new Date(),
        state: search.get("state"),
        transactionReportId: search.get("transaction_report_id"),
        accountVerificationReportId: search.get(
          "account_verification_report_id"
        ),
      },
    });
  };

  return <></>;
}
